import React from 'react';

const HomeContext = React.createContext({
  bodyScrollTop: 0,
});

export default HomeContext;